import React, { useState, useEffect } from "react";
import {
  ShoppingCart,
  Heart,
  Search,
  Menu,
  X,
  Phone,
  MapPinHouse,
  LogOut,
  User,
  Package,
  ShoppingBag
} from "lucide-react";
import a2 from "./a2.png";
import { useNavigate } from "react-router-dom";
import LoginForm from "./Loginform/LoginForm";
import CartPage from "../Cartpage/CartPage";
import MyOrdersPage from "../MyCartPage/MyOrdersPage";
import { useAuth } from "../../context/AuthContext";

import "./Navbar.css";
import api from '../../utils/axiosConfig';
import { useCart } from "../../context/CartContext";

const Navbar = ({ searchTerm, setSearchTerm, products = [], getImageUrl }) => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isOrdersOpen, setIsOrdersOpen] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const { cartData, fetchCartData, addToCart } = useCart();

  // Fetch cart data when user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchCartData();
    }
    // } else {
    //   fetchCartData()({ totalAmount: 0, totalItems: 0 });
    // }
  }, [isAuthenticated]);

  // Function to fetch cart data
  // const fetchCartData = async () => {
  //   try {
  //     // Replace with actual cart API call
  //     // const response = await cartAPI.getCart();
  //     // fetchCartData()({ 
  //     //   totalAmount: response.cart.totalAmount, 
  //     //   totalItems: response.cart.totalItems 
  //     // });

  //     // Mock data for now
  //     fetchCartData()({ totalAmount: 0, totalItems: 0 });
  //   } catch (error) {
  //     console.error("Error fetching cart data:", error);
  //   }
  // };
  const handleSearch = () => {
    if (!searchTerm.trim()) return;

    const foundProduct = products.find(
      (p) => p.name.toLowerCase() === searchTerm.toLowerCase()
    );

    const historyItem = {
      name: searchTerm,
      image: foundProduct?.images?.[0]?.path || null
    };

    const updated = [
      historyItem,
      ...searchHistory.filter((item) => item.name !== searchTerm)
    ].slice(0, 5);

    localStorage.setItem("searchHistory", JSON.stringify(updated));
    setSearchHistory(updated);

    navigate(`/search?query=${encodeURIComponent(searchTerm)}`);
    setShowHistory(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const openLoginForm = () => {
    setIsLoginFormOpen(true);
  };

  const closeLoginForm = () => {
    setIsLoginFormOpen(false);
  };

  useEffect(() => {
    const savedHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];
    setSearchHistory(savedHistory);
    console.log("[Navbar] Cart context updated:", cartData);
  }, [cartData]);

  const handleCartClick = () => {
    if (!isAuthenticated) {
      openLoginForm();
      return;
    }
    navigate('/cart');
  };

  const handleOrdersClick = () => {
    if (!isAuthenticated) {
      openLoginForm();
      return;
    }
    navigate("/myorder");
  };

  const closeCart = () => {
    setIsCartOpen(false);
    if (isAuthenticated) {
      fetchCartData();
    }
  };

  const closeOrders = () => {
    setIsOrdersOpen(false);
  };

  const handleLoginSuccess = (userData) => {
    // Auth context already updated, just fetch cart data
    fetchCartData();
  };

  const handleLogout = async () => {
    await logout();
    setShowProfileDropdown(false);
    fetchCartData();
  };

  const toggleProfileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  // Get user display name
  const getUserDisplayName = () => {
    if (!user) return "";

    if (user.fullName) return user.fullName;
    if (user.name) return user.name;
    if (user.given_name && user.family_name) return `${user.given_name} ${user.family_name}`;
    if (user.given_name) return user.given_name;

    return user.email ? user.email.split('@')[0] : "User";
  };
  // Ensure badge updates immediately whenever cartData changes
  useEffect(() => {
    // This ensures Navbar re-renders whenever cartData changes
    console.log("[Navbar] Cart updated:", cartData.totalItems);
  }, [cartData]);

  // Get user avatar/profile pic
  const getUserAvatar = () => {
    if (!user) return null;

    if (user.profilePicture) return user.profilePicture;
    if (user.picture) return user.picture;

    return null;
  };

  // Format cart value
  const formatCartValue = () => {
    if (!isAuthenticated || cartData.totalAmount === 0) return "₹0.00";
    return `₹${cartData.totalAmount.toLocaleString()}`;
  };

  // If orders page is open, show orders page
  if (isOrdersOpen) {
    return <MyOrdersPage onBack={closeOrders} />;
  }

  // If cart is open, show cart page
  if (isCartOpen) {
    return <CartPage onBack={closeCart} />;
  }

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="enhanced-navbar">
      {/* Top Information Bar */}
      <div className="top-info-bar">
        <div className="contact-info">
          <span>
            <Phone size={16} />
            +91 98673 78209
          </span>
          <span>
            <MapPinHouse size={16} /> Navi Mumbai
          </span>
        </div>
        <div className="auth-links">
          {isAuthenticated ? (
            <div className="user-profile-container">
              <div className="user-profile" onClick={toggleProfileDropdown}>
                {getUserAvatar() ? (
                  <img src={getUserAvatar()} alt="Profile" className="user-avatar" />
                ) : (
                  <div className="user-avatar-placeholder">
                    {getUserDisplayName().charAt(0).toUpperCase()}
                  </div>
                )}
                <span className="user-name">{getUserDisplayName()}</span>
              </div>

              {showProfileDropdown && (
                <div className="profile-dropdown">
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      handleOrdersClick();
                      setShowProfileDropdown(false);
                    }}
                  >
                    <Package size={16} />
                    My Orders
                  </button>
                  <button className="dropdown-item logout-btn" onClick={handleLogout}>
                    <LogOut size={16} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <a className="login-btn" onClick={openLoginForm}>
              Login / Register
            </a>
          )}
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="main-nav">
        <div className="logo-container" onClick={handleLogoClick}>
          <img src={a2} alt="Store Logo" className="logo" />
        </div>

        <div className="search-container">
          <input
            type="text"
            placeholder="Search products..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); }}
            onFocus={() => setShowHistory(true)}
            onBlur={() => {
              setTimeout(() => setShowHistory(false), 150);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <button className="search-button" onClick={handleSearch}>
            <Search size={20} />
          </button>
          {showHistory && searchHistory.length > 0 && (
            <div className="search-suggestions">
              {searchHistory.map((item, index) => (
                <div className="suggestion-item" key={index}>

                  <Search size={20} />
                  <div
                    className="suggestion-content"
                    onMouseDown={() => {
                      setSearchTerm(item.name || item);
                      setShowHistory(false);
                    }}
                  >
                    <div className="suggestion-title">{item.name || item}</div>
                    {/* <div className="suggestion-category">in {item.category || "Products"}</div> */}
                  </div>

                  <span
                    className="delete-suggestion"
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      const updated = searchHistory.filter((s) => s !== item);
                      setSearchHistory(updated);
                      localStorage.setItem("searchHistory", JSON.stringify(updated));
                    }}
                  >
                    ✕
                  </span>

                </div>

              ))}
            </div>
          )}
        </div>

        <div className="nav-actions">
          {/* My Orders Button */}
          <div className="nav-icon orders-icon-container" onClick={handleOrdersClick}>
            <div className="orders-icon-wrapper">
              <ShoppingBag size={24} color="#28a745" className="icon-orders" />
            </div>
            {/* <span className="orders-label">Orders</span> */}
          </div>

          {/* Cart Button */}
          <div className="nav-icon cart-icon-container" onClick={handleCartClick}>
            <div className="cart-icon-wrapper">
              <ShoppingCart size={24} className="icon-cart" />
              {/* Show badge only if there are items */}
              {isAuthenticated && cartData.totalItems > 0 && (
                <span className="cart-badge">{cartData.totalItems}</span>
              )}
            </div>
          </div>


          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Mobile Drawer Menu */}
          {isMobileMenuOpen && (
            <>
              {/* Overlay background */}
              <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)} />

              {/* Slide-in Drawer */}
              <div className="mobile-menu-drawer">
                <div className="mobile-menu-header">
                  <h3>Menu</h3>
                  <X size={24} className="close-icon" onClick={() => setIsMobileMenuOpen(false)} />
                </div>
                <ul className="mobile-menu-links">
                  <li onClick={() => { navigate('/'); setIsMobileMenuOpen(false); }}>
                    Home
                  </li>
                  <li onClick={() => { navigate('/about'); setIsMobileMenuOpen(false); }}>
                    About Us
                  </li>
                  <li onClick={() => { navigate('/contact'); setIsMobileMenuOpen(false); }}>
                    Contact
                  </li>
                  {isAuthenticated && (
                    <li onClick={() => { handleOrdersClick(); setIsMobileMenuOpen(false); }}>
                      My Orders
                    </li>
                  )}
                </ul>
              </div>
            </>
          )}
        </div>
      </nav>

      {isLoginFormOpen && (
        <LoginForm
          onClose={closeLoginForm}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </header>
  );
};

export default Navbar;